'use strict'; // dns-nodejs gets replaced by dns-browser when webpacked/browserified

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var dns = require('../runtime/dns-nodejs');

var _require = require('../utils'),
    withTimeoutOption = _require.withTimeoutOption;

function fqdnFixups(domain) {
  // Allow resolution of .eth names via .eth.link
  // More context at the go-ipfs counterpart: https://github.com/ipfs/go-ipfs/pull/6448
  if (domain.endsWith('.eth')) {
    domain = domain.replace(/.eth$/, '.eth.link');
  }

  return domain;
}

module.exports = function () {
  return withTimeoutOption( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domain, opts) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              opts = opts || {};

              if (!(typeof domain !== 'string')) {
                _context.next = 3;
                break;
              }

              throw new Error('Invalid arguments, domain must be a string');

            case 3:
              domain = fqdnFixups(domain);
              return _context.abrupt("return", dns(domain, opts));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};